module.exports = __webpack_public_path__ + "static/about-8ebc6f13758fa118d54194f9dc222f52.svg";